import type { IconNode } from '../types';

/**
 * @name dress
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTYgMnYzYTUuMTQgNS4xNCAwIDAgMSAuNyA0LjhsLS4yLjVhNy42NCA3LjY0IDAgMCAwIC40IDYuM0MxNy43IDE3LjkgMTkgMjAgMTkgMjBzLTMuMSAyLTcgMi03LTItNy0yIDEuMy0yLjEgMi4xLTMuNWE3LjY0IDcuNjQgMCAwIDAgLjQtNi4ybC0uMi0uNUE1LjY2IDUuNjYgMCAwIDEgOCA1VjIiIC8+CiAgPHBhdGggZD0iTTE2IDVjLTEuOCAwLTMuMyAxLTQgMi41QzExLjMgNiA5LjggNSA4IDUiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/dress
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const dress: IconNode = [
  [
    'path',
    {
      d: 'M16 2v3a5.14 5.14 0 0 1 .7 4.8l-.2.5a7.64 7.64 0 0 0 .4 6.3C17.7 17.9 19 20 19 20s-3.1 2-7 2-7-2-7-2 1.3-2.1 2.1-3.5a7.64 7.64 0 0 0 .4-6.2l-.2-.5A5.66 5.66 0 0 1 8 5V2',
      key: '10k3lb',
    },
  ],
  ['path', { d: 'M16 5c-1.8 0-3.3 1-4 2.5C11.3 6 9.8 5 8 5', key: '7jp3y9' }],
];

export default dress;
